export const formValues = {
	asset_id: null,
	asset_type_id: null,
	ata_chapter: null,
	part_description: null,
	part_number: null,
	part_serial_number: null,
	part_installation_date: null,
	aircraft_tsn: null,
	aircraft_csn: null,
	part_tsn: null,
	part_csn: null,
	remark: null,
	component: null,
	position: null,
	occm_requirement: null,
	faa_easa_certificate: null,
	shop_report: null,
	conformity_certificate: null,
	receipt_note: null,
	work_order: null,
	attachments: [],
	checklist: [],
	folder_uuid: null
}

export const taskErrorCode = {
	ata_chapter: {
		0: "",
		1: "Required",
	},
	ata_chapter_obj: {
		required: true,
	},
	part_number: {
		0: "",
		1: "Required",
	},
	part_number_obj: {
		required: true,
	},
	part_installation_date: {
		0: "",
		1: "Required",
		5: "Please enter valid date",
	},
	part_installation_date_obj: {
		required: true,
		datePattern: true,
	},
	part_serial_number: {
		0: "",
		1: "Required",
	},
	part_serial_number_obj: {
		required: true,
	},
	position: {
		0: "",
		1: "Required",
	},
	position_obj: {
		required: true,
	},
	faa_easa_certificate: {
		0: "",
		1: "Required",
	},
	faa_easa_certificate_obj: {
		required: true,
		radioGroup: true,
	},
	part_description: {
		0: "",
		1: "Required",
	},
	part_description_obj: {
		required: true,
	},
}
